import React, { useState } from 'react'
import Typography from "@material-ui/core/Typography";
import {makeStyles} from "@material-ui/core";
import QRCode from 'qrcode'


export const useStyles = makeStyles(() => ({
    text: {
        display: 'flex',
        textAlign: 'center',
        alignItems: 'center',
    },
    qrReal: {
        height: '200px',
        maxWidth: '200px',
    },
    qr: {
        height: '50px',
        maxWidth: '50px',
    }
}))

const QrCodeViolation = ({qrHash}) => {
    
  
 
    const [link, setLink] = useState('')
   
    if (qrHash !== null && qrHash !== '')  {
        const adress = 'https://ma.gasoilcenter.ru/qr_violation/' + qrHash
        QRCode.toDataURL(adress, { errorCorrectionLevel: 'Q' })
        .then(url => {
            setLink(url) 
        })
        .catch(err => {
            console.error(err)
        })
    }
    const classes = useStyles()

    return (
        <>
        {link !== '' && qrHash !== undefined &&
            <>
                <Typography className={classes.text} variant='h6'>QR код нарушения</Typography>
                <div className={classes.qrReal}>
                     <img src={link} />
                </div>
               
            </>
        }  
          
        </>
    )

}

export default QrCodeViolation;
